module.exports = __webpack_public_path__ + "24e3e989077a6d8be8b1a0dee8ea50bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-24.png
// module id = 2104
// module chunks = 0